<template>
  <div>
    <v-app-bar :color="color" dark app class=" px-xs-0 mt-8 px-md-10">
      <!-- <v-btn text to="/"> -->
      <v-avatar tile height="36">
        <v-img :src="require('@/assets/logo-argecam.png')"></v-img>
      </v-avatar>
      <v-toolbar-title
        class="font-weight-bold primary--text mx-3 mt-2 text-uppercase"
        style="letter-spacing: .1em;"
      >
        Argecam SRL
        <!-- ARGECAM <span class="font-weight-bold accent--text">SRL</span> -->
      </v-toolbar-title>
      <!-- </v-btn> -->

      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
          v-for="sec in items"
          class="text-caption white--text"
          color="primary"
          :key="sec.name"
          :to="sec.to"
          text
          >{{ sec.name }}

          <!-- @click="$vuetify.goTo(sec.to, 500, 0)" -->
        </v-btn>
      </v-toolbar-items>

      <v-app-bar-nav-icon
        class="hidden-md-and-up primary--text"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
    </v-app-bar>
    <app-bar-drawer
      v-model="drawer"
      :items="items"
      :title="title"
      :subtitle="subtitle"
    />
  </div>
</template>

<script>
export default {
  components: {
    AppBarDrawer: () => import("./TheDrawer")
  },
  data: () => ({
    drawer: false,
    title: "ARGECAM SRL",
    subtitle: "SUBTITULOS",
    items: [
      { name: "home", to: "/" },
      { name: "nosotros", to: "nuestra-empresa" },
      { name: "servicios", to: "servicios" },
      { name: "equipos", to: "equipos" },
      { name: "clientes", to: "nuestros-clientes" },
      { name: "obras", to: "nuestras-obras" },
      { name: "contacto", to: "contacto" }
    ]
  }),
  props: {
    color: {
      type: String,
      default: "primary"
    },
    flat: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.ancho-barra {
  width: 90% !important;
}
.back-barra {
  width: 100%;
  background-color: red !important;
}
</style>
